@if (meet) {
  <!-- first sidebar   -->
  <div class="d-none d-lg-flex flex-column flex-shrink-0 first-side-menu">
    <ul class="nav nav-pills nav-flush flex-column mb-auto text-center">
      <!-- Home -->
      <li class="nav-item">
        <a
          routerLink="/meets/{{ meet.id }}"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="nav-link"
        >
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.home" [fixedWidth]="true"></fa-icon>
            <div i18n="Home Tab Title on the Main sidebar@@desktopFirstSidebar.homeTabTitle">Home</div>
          </span>
        </a>
      </li>
      <!-- Live -->
      @if (meet.allowFieldScoreboard || meet.allowScoreboard) {
        <li class="nav-item">
          <a routerLink="/meets/{{ meet.id }}/live" routerLinkActive="active" class="nav-link">
            <span class="d-flex flex-column">
              <fa-icon [icon]="environment.icons.live" [fixedWidth]="true"></fa-icon>
              <div i18n="Live Tab Title on the Main sidebar@@desktopFirstSidebar.liveTabTitle">Live</div>
            </span>
          </a>
        </li>
      }
      <!-- Events -->
      <li class="nav-item">
        <a routerLink="/meets/{{ meet.id }}/events" routerLinkActive="active" class="nav-link">
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.events" [fixedWidth]="true"></fa-icon>
            <div i18n="Events Tab Title on the Main sidebar@@desktopFirstSidebar.eventsTabTitle">Events</div>
          </span>
        </a>
      </li>
      <!-- Check-In -->
      @if (meet.checkIn) {
        <li class="nav-item">
          <a routerLink="/meets/{{ meet.id }}/checking-in-now" routerLinkActive="active" class="nav-link">
            <span class="d-flex flex-column">
              <fa-icon [icon]="environment.icons.doorOpen" [fixedWidth]="true"></fa-icon>
              <div i18n="Check-In Tab Title on the Main sidebar@@desktopFirstSidebar.checkInTabTitle">Check-In</div>
            </span>
          </a>
        </li>
      }
      <!-- Follow -->
      <li>
        <a routerLink="/meets/{{ meet.id }}/follow" routerLinkActive="active" class="nav-link">
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.followOn" [fixedWidth]="true"></fa-icon>
            <div i18n="Follow Tab Title on the Main sidebar@@desktopFirstSidebar.followTabTitle">Follow</div>
          </span>
        </a>
      </li>
      <!-- Teams -->
      <li>
        <a routerLink="/meets/{{ meet.id }}/teams" routerLinkActive="active" class="nav-link">
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.teams" [fixedWidth]="true"></fa-icon>
            <div i18n="Teams Tab Title on the Main sidebar@@desktopFirstSidebar.teamsTabTitle">Teams</div>
          </span>
        </a>
      </li>
      <!-- Athletes -->
      <li>
        <a routerLink="/meets/{{ meet.id }}/athletes" routerLinkActive="active" class="nav-link">
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.athletes" [fixedWidth]="true"></fa-icon>
            <div i18n="Athletes Tab Title on the Main sidebar@@desktopFirstSidebar.athletesTabTitle">Athletes</div>
          </span>
        </a>
      </li>
      <!-- Scores -->
      @if (meet.scoreMeet && meet.meetScores) {
        @if (meet.sport !== 'xc') {
          <li>
            <a routerLink="/meets/{{ meet.id }}/track-scores" routerLinkActive="active" class="nav-link">
              <span class="d-flex flex-column">
                <fa-icon [icon]="environment.icons.scores" [fixedWidth]="true"></fa-icon>
                <div i18n="Team Scores Tab Title on the Main sidebar@@desktopFirstSidebar.scoresTabTitle">Scores</div>
              </span>
            </a>
          </li>
        }
      }
      <li>
        <a routerLink="/meets/{{ meet.id }}/reports/winners" routerLinkActive="active" class="nav-link">
          <span class="d-flex flex-column">
            <fa-icon [icon]="environment.icons.reports" [fixedWidth]="true"></fa-icon>
            <div i18n="Reports Tab Title on the Main sidebar@@desktopFirstSidebar.reportsTabTitle">Reports</div>
          </span>
        </a>
      </li>
      @if (meet.hasMedia) {
        <li>
          <a routerLink="/meets/{{ meet.id }}/media" routerLinkActive="active" class="nav-link">
            <span class="d-flex flex-column">
              <fa-icon [icon]="environment.icons.images" [fixedWidth]="true"></fa-icon>
              <div i18n="Media Tab Title on the Main sidebar@@desktopFirstSidebar.mediaTabTitle">Media</div>
            </span>
          </a>
        </li>
      }
      <!-- Dark Mode Toggle -->
      <li>
        @if ({ value: isDarkMode$ | async }; as isDarkMode) {
          @if (isDarkMode.value) {
            <a
              [routerLink]="undefined"
              routerLinkActive="active"
              class="nav-link nav-link--dark-mode"
              (click)="onDarkModeToggle()"
              role="button"
            >
              <span class="d-flex flex-column">
                <fa-icon [icon]="environment.icons.lightMode" [fixedWidth]="true"></fa-icon>
                <div i18n="@@desktopFirstSidebar.lightMode">Light</div>
              </span>
            </a>
          } @else {
            <a
              [routerLink]="undefined"
              routerLinkActive="active"
              class="nav-link nav-link--dark-mode"
              (click)="onDarkModeToggle()"
              role="button"
            >
              <span class="d-flex flex-column">
                <fa-icon [icon]="environment.icons.darkMode" [fixedWidth]="true"></fa-icon>
                <div i18n="@@desktopFirstSidebar.darkMode">Dark</div>
              </span>
            </a>
          }
        }
      </li>
    </ul>
  </div>
  <div #secondSideMenu class="d-flex flex-column flex-shrink-0 second-side-menu second-side-menu--open">
    <div class="sidebar-search p-3 pb-0">
      @if (siteConfig$ | async; as siteConfig) {
        @if (!siteConfig.ngConfig.primarySite) {
          <div class="mb-3 text-center">
            @if ({ value: isDarkMode$ | async }; as isDarkMode) {
              @if (isDarkMode.value) {
                <a [href]="siteConfig.ngConfig.siteUrl">
                  <img
                    style="height: 50px; max-width: 259px"
                    [src]="siteConfig.ngConfig.sideMenuImageDarkModeUrl"
                    [alt]="siteConfig.ngConfig.siteName"
                  />
                </a>
              } @else {
                <a [href]="siteConfig.ngConfig.siteUrl">
                  <img
                    style="height: 50px; max-width: 259px"
                    [src]="siteConfig.ngConfig.sideMenuImageUrl"
                    [alt]="siteConfig.ngConfig.siteName"
                  />
                </a>
              }
            }
          </div>
        }
      }
      <div class="fs-5">
        {{ meet.name }}
      </div>
      <div class="fs-6" [ngClass]="{ 'mb-3': !showSidebarSearch }">
        {{ meet.meetDates | meetDate: meet.timeFormat : meet.dateString }}
      </div>
    </div>
    @if (showSidebarSearch) {
      <div class="sidebar-search p-3">
        <app-sidebar-search></app-sidebar-search>
      </div>
    }
    <router-outlet name="secondSidebar"></router-outlet>
  </div>
}
